import { useState, useEffect } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";

const links = [
  ["/",             "Home"],
  ["/invest",       "Invest"],
  ["/funds",        "Funds"],
  ["/borrow",       "Borrow"],
  ["/wealth",       "Wealth"],
  ["/group",        "Group"],
  ["/transactions", "Transactions"],
  ["/faqs",         "FAQs"]
];

export default function Nav() {
  const [menuOpen, setMenuOpen] = useState(false);
  const close = () => setMenuOpen(false);
  const location = useLocation();

  useEffect(() => { setMenuOpen(false); }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [menuOpen]);

  return (
    <header className="nav">
      <div className="wrap">
        <Link to="/" className="brand">
          <img src="/df-logo.png" alt="" />
          <span>Daksfirst</span>
        </Link>

        <nav className="primary">
          {links.map(([to, label]) => (
            <NavLink key={to} to={to} end={to === "/"}
                     className={({ isActive }) => (isActive ? "active" : "")}>
              {label}
            </NavLink>
          ))}
        </nav>

        <Link to="/login" className="cta-mini desktop-only">Investor sign-in</Link>

        <button type="button" className="menu-btn" onClick={() => setMenuOpen(true)}
                aria-label="Open menu" aria-expanded={menuOpen}>
          <span className="menu-icon" aria-hidden="true">
            <span></span><span></span><span></span>
          </span>
        </button>
      </div>

      {menuOpen && (
        <div className="mobile-menu" onClick={close} role="dialog" aria-modal="true">
          <div className="mobile-menu-inner" onClick={(e) => e.stopPropagation()}>
            <div className="mobile-menu-head">
              <Link to="/" className="brand" onClick={close}>
                <img src="/df-logo.png" alt="" />
                <span>Daksfirst</span>
              </Link>
              <button type="button" className="menu-close" onClick={close} aria-label="Close menu">
                ×
              </button>
            </div>

            <nav className="mobile-nav">
              {links.map(([to, label]) => (
                <NavLink key={to} to={to} end={to === "/"}
                         className={({ isActive }) => (isActive ? "active" : "")}
                         onClick={close}>
                  {label}
                </NavLink>
              ))}
            </nav>

            <Link to="/login" onClick={close} className="btn btn-primary mobile-cta">
              Investor sign-in
            </Link>

            <p className="mobile-menu-foot">
              Daksfirst Limited is an Appointed Representative of Maystone Capital Limited (FCA FRN 758412).
            </p>
          </div>
        </div>
      )}
    </header>
  );
}
